import { isAfter, subWeeks } from "date-fns";

import { browserLocalStorage } from "@/react/lib/browserStorage";

const ECLIPSE_READY_MODAL_DISMISSED_AT_KEY =
  "circle-v4-eclipse-ready-modal-dismissed-at";

const storageKey = (communityId: number | string) =>
  `${ECLIPSE_READY_MODAL_DISMISSED_AT_KEY}-${communityId}`;

export const dismissEclipseReadyModal = (communityId: number | string) => {
  browserLocalStorage.setItem(storageKey(communityId), String(Date.now()));
};

export const clearEclipseReadyModalDismissal = (
  communityId: number | string,
) => {
  browserLocalStorage.removeItem(storageKey(communityId));
};

export const wasEclipseReadyModalDismissedThisWeek = (
  communityId: number | string,
) => {
  const dismissedAt = browserLocalStorage.getItem(storageKey(communityId));

  if (!dismissedAt) return false;

  return isAfter(new Date(Number(dismissedAt)), subWeeks(new Date(), 1));
};
